import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StorageManager} from '../../storage-manager.class';

import type { OnInit } from '@angular/core';
import { RequestHandler } from 'src/app/service/OffService/request-handler';

export enum RequestButtonTypes {
    NEW,
    EDIT,
    DELETE
}
@Component({
    selector: 'app-request-button',
    standalone: false,
    templateUrl: './request-button.component.html',
    styleUrls: ['./request-button.component.scss']
})


export class RequestButtonComponent<T> implements OnInit {

    @Input() request = new RequestHandler<T>();
    @Input() lockOnSuccess = false;
    @Input() error: string | null = null;
    @Input() warning: string | null = null;
    @Input() mode: RequestButtonTypes = 0;
    @Output() clicked: EventEmitter<object> = new EventEmitter<object>();

    public failMessage: string[] = [];

    public REQUEST_BUTTON_TYPES = RequestButtonTypes;

    constructor() {
    }

    ngOnInit() {
            
        if (!this.mode) {
            this.mode = RequestButtonTypes.NEW;
        }

        if ((StorageManager.getUser() || {}).rol === 'demo') {
            this.failMessage[0] = 'Operación no permitida';
            this.failMessage[1] = '';
        } else {
            this.failMessage[0] = 'Ha ocurrido un error...';
            this.failMessage[1] = 'Volver a intentar';
        }
    }

    public requestClick() {
        //this.requestClick.emit();
    }

}
